module.exports = __webpack_public_path__ + "img/fb16.ddf376cf.jpg";